var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSettingsAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74982 12.4998H12.4998V8.74982L8.12482 4.37482C9.52435 3.70641 11.0967 3.48833 12.6253 3.7506C14.1539 4.01287 15.5637 4.74259 16.6604 5.83928C17.757 6.93598 18.4868 8.3457 18.749 9.87432C19.0113 11.4029 18.7932 12.9753 18.1248 14.3748L25.6248 21.8748C26.1221 22.3721 26.4015 23.0466 26.4015 23.7498C26.4015 24.4531 26.1221 25.1275 25.6248 25.6248C25.1275 26.1221 24.4531 26.4015 23.7498 26.4015C23.0466 26.4015 22.3721 26.1221 21.8748 25.6248L14.3748 18.1248C12.9753 18.7932 11.4029 19.0113 9.87432 18.749C8.3457 18.4868 6.93598 17.757 5.83928 16.6604C4.74259 15.5637 4.01287 14.1539 3.7506 12.6253C3.48833 11.0967 3.70641 9.52435 4.37482 8.12482L8.74982 12.4998Z",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSettingsAlt);
export default __webpack_public_path__ + "static/media/menu_settings_alt.a4f5ee2b.svg";
export { ForwardRef as ReactComponent };